import styled from 'styled-components';

export const HeaderZone = styled.div`
  padding-bottom: 2rem;
`;
